import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { changeDefaultLanguage } from 'redux/actions/topBarActions';
import useLanguages from 'hooks/useLanguages';

import CustomSelect from 'shared/components/CustomSelect';
import { colors, device } from 'shared/defaultTheme';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import TobbarProductUser from './TobbarProductUser';
import TopBarHelp from './TopBarHelp';
import TopBarButtonSearch from './TopBarButtonSearch';

const Topbar = ({
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
  logoSrc,
  backgroundColor,
  iconColor,
  textColor,
}) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const { isCustomer } = useSelector((state) => state.auth);
  const layout = useSelector((state) => state.layout);
  const { cookies } = layout;
  const { languages } = useLanguages();

  const onChangeLanguage = (event) => {
    const { target } = event;
    const { value } = target;
    i18n.changeLanguage(value);
    dispatch(changeDefaultLanguage(value));
  };

  useEffect(() => {
    i18n.changeLanguage(selectedDefaultLanguage);
  }, [selectedDefaultLanguage]);

  return (
    <div
      className={!cookies ? 'topbar cooking-display-topbar' : 'topbar'}
      style={{ backgroundColor }}
    >
      <div className="topbar__wrapper">
        <div className="topbar__left d-flex flex-row align-items-center">
          <TopbarSidebarButton
            changeMobileSidebarVisibility={changeMobileSidebarVisibility}
            changeSidebarVisibility={changeSidebarVisibility}
            iconColor={iconColor}
          />
          <NavLink to="/home">
            <Logo imageSrc={logoSrc} className="" />
          </NavLink>
        </div>
        <div className="topbar__center">
          <TopBarButtonSearch />
        </div>
        <div className="topbar__right">
          {/* <div className="topbar__right-search d-flex">
            <TopbarSearch textColor={textColor} iconColor={iconColor} />
          </div> */}
          <DropdownWrapper textColor={textColor}>
            <CustomSelect
              options={languages}
              defaultValue={selectedDefaultLanguage}
              backgroundColor={colors.transparent}
              onChange={onChangeLanguage}
            />
          </DropdownWrapper>
          {isCustomer && <TopBarHelp iconColor={iconColor} />}
          <TopbarProfile textColor={textColor} />
          {isCustomer && <TobbarProductUser iconColor={iconColor} />}
        </div>
      </div>
    </div>
  );
};

const Logo = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '100px',
  height: '49px',
}));

const DropdownWrapper = styled.div`
  @media ${device.sm} {
    display: none !important;
  }
  @media ${device.md} {
    display: none !important;
  }
  @media ${device.lg} {
    display: none !important;
  }
  @media ${device.xl} {
    display: flex !important;
  }
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 15px;
  width: auto;
  svg {
    fill: ${({ textColor }) => textColor ?? colors.black} !important;
    height: 13px;
    width: 13px;
  }
  div {
    span {
      color: ${({ textColor }) => textColor ?? colors.black} !important;
    }
  }
`;

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
  logoSrc: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
};

export default Topbar;
